import React from "react";
import Alert from "@mui/material/Alert";
import {useTranslation} from "react-i18next";
import {getManagedErrorsTranslations} from "../../translations/getManagedErrorsTranslations";

const UserErrors = ({errors}) => {
  const {t} = useTranslation();

  return errors !== null && errors !== undefined
    ? errors.map((str, index) => (
        <Alert
          severity="error"
          style={{
            marginBottom: index + 1 < errors.length ? 8 : 16
          }}
          key={index}
        >
          {getManagedErrorsTranslations(t)[str] || t("errors.user.generic")}
        </Alert>
      ))
    : null;
};

export default UserErrors;
